import { defineMessages } from 'react-intl.macro';

export const messages = defineMessages({
    classPerformanceLabel: {
        id: 'classPerformance.classPerformanceLabel',
        defaultMessage: 'Class performance',
    },
    classOverallCsatLabel: {
        id: 'classPerformance.classOverallCsatLabel',
        defaultMessage: 'Overall CSAT',
    },
    classInstructorCsatLabel: {
        id: 'classPerformance.classInstructorCsatLabel',
        defaultMessage: 'Instructor CSAT score',
    },
    classCompletedLabel: {
        id: 'classPerformance.classCompletedLabel',
        defaultMessage: 'Completed',
    },
    classAttendedLabel: {
        id: 'classPerformance.classAttendedLabel',
        defaultMessage: 'Attended',
    },
    classResponseRateLabel: {
        id: 'classPerformance.classResponseRateLabel',
        defaultMessage: 'Response Rate',
    },
});

export default messages;
